import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getBithdateByStringDate, getPersonTypeByInt, getYearsBirthByArrivalDate, isEmptyObject, verifyGuestTypeByAge } from '../utils';

function useVerifyGuestType() {
  const { selectedGuest } = useSelector((state) => state.guests);
  const { booking } = useSelector((state) => state.booking);
  const [notMatchAge, setNotMatchAge] = useState(false);

  const verifyGuestType = useCallback((birthDate) => {
    const customBirthDate = getBithdateByStringDate(birthDate);
    const guestType = verifyGuestTypeByAge(
      getYearsBirthByArrivalDate(customBirthDate, booking.FechaEntrada),
    );

    const initGuestType = getPersonTypeByInt(selectedGuest.TipoPersona);
    if (!isEmptyObject(guestType)) {
      if (guestType.id !== initGuestType.id) {
        return { isMatchGuest: false, selectedGuest, initGuestType, foundGuest: guestType };
      }
      return { isMatchGuest: true, selectedGuest, initGuestType, foundGuest: guestType };

    }
    return { isMatchGuest: false, selectedGuest, initGuestType, foundGuest: guestType };
  }, []);




  return {
    notMatchAge,
    verifyGuestType
  };
}

export default useVerifyGuestType;
